import React, { useEffect, useState } from 'react';

const ITEMS_PER_PAGE = 10;

export default function TopOrganizations() {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetch('https://api.nxtrp.pl/api/orgs')
      .then(res => res.json())
      .then(data => {
        setOrgs(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div>Ładowanie…</div>;
  if (!orgs.length) return <div>Brak danych.</div>;

  // Paginacja
  const totalPages = Math.ceil(orgs.length / ITEMS_PER_PAGE);
  const startIdx = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIdx = startIdx + ITEMS_PER_PAGE;
  const pageData = orgs.slice(startIdx, endIdx);

  return (
    <div>
      <h2>Top Organizacji</h2>
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Organizacja</th>
            <th>Punkty</th>
          </tr>
        </thead>
        <tbody>
          {pageData.map((org, i) => (
            <tr key={org.name}>
              <td>{startIdx + i + 1}</td>
              <td>
                <span className="gang-avatar" style={{ background: org.color }} title={org.name}>
                  {org.name[0]}
                </span>
                {org.name}
              </td>
              <td>{org.points}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 16, marginTop: 18 }}>
        <button className="button" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}>&larr; Poprzednia</button>
        <span style={{ margin: '0 12px', color: '#e43c92', fontWeight: 600 }}>
          Strona {currentPage} z {totalPages}
        </span>
        <button className="button" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}>Następna &rarr;</button>
      </div>
    </div>
  );
}
